var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.1387C19.4036 25.1387 25 19.5422 25 12.6387C25 5.73511 19.4036 0.138672 12.5 0.138672C5.59644 0.138672 0 5.73511 0 12.6387C0 19.5422 5.59644 25.1387 12.5 25.1387Z",
    fill: "url(#paint0_linear_444_465)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67944 11.2764C6.7215 9.89162 7.3113 8.58007 8.31939 7.62967C9.32748 6.67927 10.6715 6.16768 12.0564 6.20721C13.4413 6.16768 14.7853 6.67927 15.7933 7.62967C16.8014 8.58007 17.3912 9.89162 17.4333 11.2764C17.4333 13.447 16.1083 15.4764 14.8634 16.9175C14.3253 17.5374 13.7472 18.1213 13.1326 18.6655C12.8968 18.8745 12.6993 19.0386 12.5602 19.1514C12.4903 19.2079 12.4359 19.2508 12.3974 19.2796L12.3525 19.3162L12.3403 19.3252H12.3371C12.3371 19.3252 12.3371 19.3252 12.0602 18.9572L11.7833 19.3258H11.7801L11.7679 19.3168L11.7237 19.2829C11.6852 19.2534 11.6301 19.2098 11.5609 19.1546C11.4218 19.0425 11.2243 18.8784 10.9884 18.6687C10.3739 18.1245 9.79574 17.5406 9.25765 16.9207C8.00444 15.4764 6.67944 13.4476 6.67944 11.2764ZM12.0564 18.9572L11.7801 19.3258C11.8599 19.3856 11.9563 19.4179 12.056 19.4179C12.1558 19.4179 12.2528 19.3856 12.3326 19.3258L12.0564 18.9572ZM12.0564 18.3687C12.1788 18.2681 12.3365 18.1354 12.5192 17.9739C13.1038 17.4568 13.654 16.902 14.166 16.313C15.3782 14.9117 16.5109 13.0982 16.5109 11.2764C16.4686 10.1362 15.9758 9.05921 15.1407 8.28172C14.3055 7.50424 13.1961 7.08969 12.0557 7.129C10.9154 7.08969 9.80594 7.50424 8.97077 8.28172C8.1356 9.05921 7.64286 10.1362 7.6006 11.2764C7.6006 13.0995 8.73393 14.9111 9.94611 16.313C10.4581 16.902 11.0083 17.4568 11.5929 17.9739C11.7756 18.1361 11.9339 18.2687 12.0564 18.3687Z",
    fill: "url(#paint1_linear_444_465)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1345 9.2793C11.195 9.2793 11.2549 9.29122 11.3109 9.31438C11.3668 9.33754 11.4176 9.37149 11.4604 9.41429C11.5032 9.45709 11.5371 9.5079 11.5603 9.56382C11.5835 9.61974 11.5954 9.67967 11.5954 9.74019V14.6562C11.5954 14.7785 11.5468 14.8957 11.4604 14.9821C11.3739 15.0686 11.2567 15.1171 11.1345 15.1171C11.0122 15.1171 10.895 15.0686 10.8086 14.9821C10.7221 14.8957 10.6736 14.7785 10.6736 14.6562V9.74019C10.6736 9.67967 10.6855 9.61974 10.7087 9.56382C10.7318 9.5079 10.7658 9.45709 10.8086 9.41429C10.8514 9.37149 10.9022 9.33754 10.9581 9.31438C11.014 9.29122 11.074 9.2793 11.1345 9.2793Z",
    fill: "url(#paint2_linear_444_465)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6736 9.74019C10.6736 9.61796 10.7221 9.50073 10.8086 9.41429C10.895 9.32786 11.0122 9.2793 11.1345 9.2793H12.9781C13.4262 9.2793 13.856 9.45732 14.1729 9.77421C14.4898 10.0911 14.6678 10.5209 14.6678 10.969C14.6678 11.4172 14.4898 11.847 14.1729 12.1639C13.856 12.4808 13.4262 12.6588 12.9781 12.6588H11.1345C11.0738 12.6588 11.0137 12.6468 10.9577 12.6235C10.9016 12.6002 10.8507 12.5661 10.8079 12.5231C10.7651 12.4801 10.7312 12.4291 10.7081 12.3729C10.6851 12.3168 10.6733 12.2567 10.6736 12.196V9.74019ZM11.5954 10.2011V11.7396H12.9781C13.1821 11.7396 13.3777 11.6585 13.522 11.5143C13.6663 11.37 13.7473 11.1743 13.7473 10.9703C13.7473 10.7663 13.6663 10.5707 13.522 10.4264C13.3777 10.2821 13.1821 10.2011 12.9781 10.2011H11.5954Z",
    fill: "url(#paint3_linear_444_465)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_465",
    x1: 12.5,
    y1: 0.138672,
    x2: 12.5,
    y2: 25.1387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF005A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_444_465",
    x1: 12.0564,
    y1: 6.20508,
    x2: 12.0564,
    y2: 19.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_444_465",
    x1: 11.1345,
    y1: 9.2793,
    x2: 11.1345,
    y2: 15.1171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_444_465",
    x1: 12.6707,
    y1: 9.2793,
    x2: 12.6707,
    y2: 12.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADAE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingGraphic);
export default __webpack_public_path__ + "static/media/floating-graphic.746650fb384734ecdcf8ebc194a489bc.svg";
export { ForwardRef as ReactComponent };